import {
  GET_DOCUMENTS,
  GET_DOCUMENTS_SUCCESS,
  GET_DOCUMENTS_FAIL,
  GET_DOCUMENT_BY_ID,
  GET_DOCUMENT_BY_ID_SUCCESS,
  GET_DOCUMENT_BY_ID_FAIL,
  ADD_DOCUMENT,
  ADD_DOCUMENT_SUCCESS,
  ADD_DOCUMENT_FAIL,
  DELETE_DOCUMENT,
  DELETE_DOCUMENT_SUCCESS,
  DELETE_DOCUMENT_FAIL,
  CLEAR_DOCUMENTS,
  RESET_DOCUMENT_FLAG,
} from "./actionTypes"

const INIT_STATE = {
  lstDocuments: [],
  currentDocument: null,
  error: "",
  success: "",
  loading: false,
  uploadLoading: false,
}

const Documents = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Get Documents
    case GET_DOCUMENTS:
      return {
        ...state,
        loading: true,
      }

    case GET_DOCUMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        lstDocuments: action.payload,
      }

    case GET_DOCUMENTS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // Get Document By Id
    case GET_DOCUMENT_BY_ID:
      return {
        ...state,
        loading: true,
      }

    case GET_DOCUMENT_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        currentDocument: action.payload,
      }

    case GET_DOCUMENT_BY_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // Add Document
    case ADD_DOCUMENT:
      return {
        ...state,
        uploadLoading: true,
      }

    case ADD_DOCUMENT_SUCCESS:
      return {
        ...state,
        uploadLoading: false,
        error: "",
        lstDocuments: [...state.lstDocuments, action.payload],
        success: "فایل با موفقیت آپلود شد",
      }

    case ADD_DOCUMENT_FAIL:
      return {
        ...state,
        uploadLoading: false,
        error: action.payload,
      }

    // Delete Document
    case DELETE_DOCUMENT:
      return {
        ...state,
        loading: true,
      }

    case DELETE_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        lstDocuments: state.lstDocuments.filter(doc => doc.id !== action.payload),
        success: "فایل با موفقیت حذف شد",
      }

    case DELETE_DOCUMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // Clear Documents
    case CLEAR_DOCUMENTS:
      return {
        ...state,
        lstDocuments: [],
        currentDocument: null,
        error: "",
        success: "",
      }

    // Reset Flag
    case RESET_DOCUMENT_FLAG:
      return {
        ...state,
        error: "",
        success: "",
      }

    default:
      return state
  }
}

export default Documents
